import React from 'react';
import { ViewerImage } from './types';
import { FixedContentContainer } from '../FixedPositionPortalContainer';
import { View } from 'react-native';
import { ActionButtonLayout } from '../ActionButtonLayout';
import { getIntl } from '../../../utils/intl';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';

const intl = getIntl('web-image-view', {
    close: 'Close',
    open: 'Open',
});

export type WebImageViewOwnProps = {
    images: ViewerImage[];
    imageIndex: number;
    isOpen: boolean;
    onClose: () => void;
};

export type WebImageViewProps = WebImageViewOwnProps;

const WebImageView: React.FC<WebImageViewProps> = ({ images, imageIndex, isOpen, onClose }) => {
    if (!isOpen) return null;

    const targetImage = images[imageIndex];

    if (!targetImage) return null;

    return (
        <FixedContentContainer>
            <View
                style={{
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                }}
            >
                <ActionButtonLayout
                    restrictedWidthVariant="lg"
                    actions={[
                        {
                            title: intl('close'),
                            icon: 'XCircle',
                            variant: 'secondary',
                            onPress: onClose,
                            testID: 'close-image-view',
                        },
                        {
                            title: intl('open'),
                            icon: 'ExternalLink',
                            variant: 'secondary',
                            onPress: () => {
                                window.open(targetImage.imageFetchUrl, '_blank');
                            },
                        },
                    ]}
                >
                    <TransformWrapper initialScale={1} initialPositionX={0} initialPositionY={0}>
                        {() => (
                            <>
                                <TransformComponent
                                    wrapperStyle={{
                                        width: '100%',
                                        height: '100%',
                                    }}
                                    contentStyle={{
                                        width: '100%',
                                        height: '100%',
                                    }}
                                >
                                    <div
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <img
                                            src={targetImage.uri}
                                            alt={targetImage.description}
                                            style={{
                                                maxWidth: '100%',
                                                maxHeight: '100%',
                                                objectFit: 'contain',
                                            }}
                                        />
                                    </div>
                                </TransformComponent>
                            </>
                        )}
                    </TransformWrapper>
                </ActionButtonLayout>
            </View>
        </FixedContentContainer>
    );
};

export default React.memo(WebImageView);
